define('viewmodels/pages/cash/methods/skrill/AddSkrillDepositViewModel',[],function () {

    function AddSkrillDepositViewModel(DepositAmountStep, formFields, depositPage, depositModel, Wizard) {

        var methodModel = depositModel.methodModel(),
            wizardModel;

        this.wizardModel = wizardModel = new Wizard({
            steps: [
                {
                    field: formFields.emailField( methodModel.email ),
                    label: depositPage.findFieldByName('skrill_email_label'),
                    smallInfo: '',
                    type: 'basicfield'
                },
                new DepositAmountStep(depositModel)
            ]
        });
    }

    AddSkrillDepositViewModel.prototype.getView = function() {
        return 'views/pages/cash/methods/wizardMethod.html';
    };

    return AddSkrillDepositViewModel;
});


